/**
 * @flow
 * @file Creates an API Context
 * @author Box
 */
import * as React from 'react';
import API from '../../../api';

export default React.createContext<?API>();
